import { Typography } from '@mui/material'
import React, { memo } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'

interface Props {
  isSearchUsed: boolean
}

const EmptyOpportunitiesComponent = ({ isSearchUsed }: Props) => {
  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col py-8`}>
      {/* Decorative: the heading below already carries the meaning, so screen readers skip the art. */}
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} alt="" />
      <Typography css={tw`mb-1 mt-2`} variant="h4" fontWeight={600}>
        {isSearchUsed ? 'No opportunities found' : 'No opportunities yet'}
      </Typography>
      <Typography color={colors.SHADES_GREY_400} variant="body2">
        {isSearchUsed
          ? 'Please try a different search query.'
          : 'Create one to get a shareable application link. Candidates who apply land in your pool at no cost.'}
      </Typography>
    </div>
  )
}

export const EmptyOpportunities = memo(EmptyOpportunitiesComponent)
